import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const StyledVpInfoBanner = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  backgroundColor: theme.palette.vpColors.blueBackgroundLight,
  border: '1px solid',
  borderColor: theme.palette.vpColors.blueMain,
  color: theme.palette.vpColors.blueMain,
  borderRadius: '6px',
  padding: '24px',
  maxWidth: '100%',
  gap: '15px',
  justifyContent: 'center',
  alignItems: 'start',
  '& .MuiTypography-root': {
    color: theme.palette.vpColors.blueMain,
    fontSize: '1em'
  }
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpInfoBanner/styles.js